/* global process */
import * as TimeUtils from '../lib/TimeUtils';

const MAX_RECENT_ACTIONS_SIZE = 10;

// Actions that happen a lot in the background you probably don't care about but flood the logs
const BACKGROUND_ACTIONS = new Set([
  'SET_SCROLL_POS',
  'SET_PERSISTING_STATE',
  'TOGGLE_OFFLINE_MODE',
  'IDLE_MONITOR_UPDATE',
  'SET_DISPLAY_AD_TIMESTAMP',
  'SET_DISPLAY_AD_URL',
  'CLEAR_STATS_EVENTS',
  'AUDIO_UPDATE',
  'AUDIO_DURATION',
  'SEARCH_RECOMMENDATIONS_SUCCESS',
  'SERVICE_OK',
]);

export const recentActions = [];
export const recentBackgroundActions = [];

function isBackgroundAction(action) {
  return BACKGROUND_ACTIONS.has(action.type);
}

export function actionsSnapshotUpdater() {
  let actionsIndex = 0;
  let backgroundActionsIndex = 0;
  return action => {
    if (isBackgroundAction(action)) {
      recentBackgroundActions[backgroundActionsIndex] = {
        action: Object.assign({}, action),
        timestamp: TimeUtils.getNow(),
      };
      backgroundActionsIndex = (backgroundActionsIndex + 1) % MAX_RECENT_ACTIONS_SIZE;
    } else {
      recentActions[actionsIndex] = {
        action: Object.assign({}, action),
        timestamp: TimeUtils.getNow(),
      };
      actionsIndex = (actionsIndex + 1) % MAX_RECENT_ACTIONS_SIZE;
    }
  };
}

function timestampSort(actionA, actionB) {
  return actionA.timestamp - actionB.timestamp;
}

// Deep clone
function cloneArrayOfObjects(arr) {
  return JSON.parse(JSON.stringify(arr));
}

// Direct method for stats
export function getRecentActions({ includeBackgroundActions = false, includeData = false } = {}) {
  if (!recentActions && !recentBackgroundActions) {
    return;
  }
  let actions = cloneArrayOfObjects(recentActions);
  if (includeBackgroundActions) {
    actions = actions.concat(cloneArrayOfObjects(recentBackgroundActions));
    actions = actions.sort(timestampSort);
  }
  if (!includeData) {
    actions.map(action => {
      if (action.action.data) delete action.action.data;
    });
  }
  return actions;
}

function formatNestedObj(obj) {
  let output = '{ ';
  for (const key of Object.keys(obj)) {
    if (obj[key] === null) {
      obj[key] = 'null';
    }
    if (typeof obj[key] === 'object') {
      output += `${key}: ${formatNestedObj(obj[key])}`;
    } else {
      output += `${key}: ${obj[key]}`;
    }
    output += ' | ';
  }
  return output + ' }';
}

// Method for debugging
/* eslint-disable */
export function prettyPrintActionObj(action) {
  let output = [`%c${action.type}`, 'color: blue'];
  if (!action.data) {
    return console.log(...output);
  }
  output.push(':');
  output.push(formatNestedObj(action.data));
  console.log(...output);
}

export function printRecentActions({ includeBackgroundActions = false, includeData = false } = {}) {
  const actions = getRecentActions({ includeBackgroundActions, includeData });
  console.log(`\nSnapshot of ${actions.length} actions:`);
  actions.map(action => {
    if (action) {
      prettyPrintActionObj(action.action);
    }
  });
}
/* eslint-enable */

if (process.env.NODE_ENV === 'development') {
  window.actionsSnapshot = printRecentActions;
}

function wrappedNoop() {
  return () => {};
}

export default {
  recentActions,
  printRecentActions,
  actionsSnapshotUpdater:
    process.env.NODE_ENV === 'development' ? actionsSnapshotUpdater : wrappedNoop,
};
